<template lang="pug">
	#barraConversao
		//- a(:href="urlInscricao" target="_blank").button Inscreva-se Aqui
		a(href="tel:08007044955") ligue 0800 704 4955
</template>

<script>
	import UtilsFael from '@lib/utilsFael'

	export default {
		name: "component-barra-conversao",
		data() {
			return {
				urlInscricao: '',
				cursoId:false,
			}
		},
		created() {
			this.urlInscricao = this.getUrl();
			this.$eventbus.$on('curso-id-url', event => this.addCursoIdUrl(event))
		},
		watch:{
			'$route':function () {
				this.cursoId = false;
				this.urlInscricao = this.getUrl();
			}
		},
		methods: {
			getUrl() {
				if(this.cursoId !== false)
					return UtilsFael.getUrlInscricao(this.cursoId);
				return UtilsFael.getUrlInscricao();
			},
			addCursoIdUrl(cursoId){
				// console.log('teste');
				this.cursoId = cursoId;
				this.urlInscricao = this.getUrl();
			}
		}

	}
</script>

<style lang="stylus" scoped src="./BarraConversao.styl"></style>
